/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WalletServiceSettingResponse } from '../models/WalletServiceSettingResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WalletServiceSettingRepository {

  /**
   * ウォレットサービス設定値取得
   * @returns WalletServiceSettingResponse OK
   * @throws ApiError
   */
  public static walletServiceSetting({
    walletServiceIds,
  }: {
    /**
     * ウォレットサービスID
     */
    walletServiceIds: Array<string> | undefined,
  }): CancelablePromise<WalletServiceSettingResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/wallet_service_setting',
      query: {
        'walletServiceIds': walletServiceIds,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        404: `Not Found`,
        500: `Internal Server Error`,
      },
    });
  }

}
